import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';

const _getScoreRecordDepartment = (scoreRecord) => {
  try {
    return scoreRecord.scores[0].criteria.department.name
  } catch (e) {
    return ''
  }
};

const _getScoreRecordType = (scoreRecord) => {
  try {
    if(scoreRecord.scores[0].store.old) {return 'Εξάμηνη'}
    if(scoreRecord.scores[0].store.newComing) {return 'Υφιστάμενη'}
    if(scoreRecord.scores[0].store.new) {return 'Νέα'}
  } catch (e) {
    return ''
  }
};


const INITIAL_STATE = fromJS({
  scoreRecords: fromJS([]),
  initialScoreRecords: fromJS([]), //used for local filtering
  fetching: false,
  message: '',
  filterModalOpen: false
});

function getScoreRecords(state, action) {
  return state
    .set('fetching', true)
}

function getScoreRecordsSuccess(state, action) {
  const records = action.payload.body.map(item => ({
    ...item,
    type: _getScoreRecordType(item),
    department: _getScoreRecordDepartment(item),
  }));
  return state
    .set('fetching', false)
    .set('scoreRecords', fromJS(records))
    .set('initialScoreRecords', fromJS(records))
}

function getScoreRecordsFailed(state, action) {
  return state
    .set('fetching', false);
}

function resetState(state, action) {
  return INITIAL_STATE;
}

function filterScoreRecordsLocally(state, action) {
  let filteredList = state.get('initialScoreRecords');
  if(action.payload.filterForm.department){
    filteredList = filteredList.filter(scoreRecord => {
      const depName = scoreRecord.get('department');
      return depName === action.payload.filterForm.department
    })
  }
  if(action.payload.filterForm.type){
    filteredList = filteredList.filter(scoreRecord => {
      const type = scoreRecord.get('type');
      return type === action.payload.filterForm.type
    })
  }
  if(action.payload.filterForm.email){
    filteredList = filteredList.filter(scoreRecord => {
      const email = scoreRecord.getIn(['person', 'email']);
      return email.toLowerCase().includes(action.payload.filterForm.email.toLowerCase())
    })
  }
  return state
    .set('scoreRecords', filteredList)
    .set('filterModalOpen', false)
}

function openScoreRecordsFilterModal(state, action) {
  return state
    .set('filterModalOpen', true)
}

function closeScoreRecordsFilterModal(state, action) {
  return state
    .set('filterModalOpen', false)
}

export const scoreRecords = createReducer(INITIAL_STATE, {
  [ActionTypes.GET_SCORE_RECORDS]: getScoreRecords,
  [ActionTypes.GET_SCORE_RECORDS_SUCCESS]: getScoreRecordsSuccess,
  [ActionTypes.GET_SCORE_RECORDS_FAILED]: getScoreRecordsFailed,
  '@@router/LOCATION_CHANGE': resetState,
  [ActionTypes.FILTER_SCORE_RECORDS_LOCALLY]: filterScoreRecordsLocally,
  [ActionTypes.OPEN_SCORE_RECORDS_FILTER_MODAL]: openScoreRecordsFilterModal,
  [ActionTypes.CLOSE_SCORE_RECORDS_FILTER_MODAL]: closeScoreRecordsFilterModal,
});



// WEBPACK FOOTER //
// ./src/reducers/scoreRecords.js